import React from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import styles from './index.module.scss'
import EmptyIcon from '../icons/EmptyIcon';
import cn from 'classnames';

const EmptyContent = () => {
  const { t } = useTranslation(); // Instantiate the hook
  return (
    <div className={cn("text-center mb-4", styles.wrapper)}>
      <EmptyIcon/>
      <div className={styles.empty_text}>{t('common.emptyContentText')}</div>
    </div>
  );
};

export default EmptyContent;
